import { MenuButtonPlugin } from "paella-core";

import defaultCogIcon from "../icons/resolutionIcon.svg";

export default class QualitySelectorPlugin extends MenuButtonPlugin {
    getAriaLabel() {
        return "Select video quality and language";
    }

    getDescription() {
        return this.getAriaLabel();
    }

    async getDictionaries() {
        return {
            hu: {
                "Select video quality and language": "Videó minősége és nyelve"
            }
        };
    }

    createVideoQuality(content = "presenter") {
        const stream = this.player.videoManifest.streams.find(
            item => item.content === content
        );

        const videoPlayer =
            this.player.videoContainer.streamProvider
                .streams[content].player;

        return new VideoQuality(
            videoPlayer,
            stream?.sources?.mp4 ?? []
        );
    }

    async isEnabled() {
        if (!(await super.isEnabled())) {
            return false;
        }

        this._quality = this.createVideoQuality();

        return this._quality.qualities.length > 0;
    }

    async load() {
        this.icon =
            this.player.getCustomPluginIcon(
                "hu.kifu.paella.qualitySelector",
                "screenIcon"
            ) || defaultCogIcon;

        await this.updateQualityLabel();
    }

    async getMenu() {
        this._quality = this.createVideoQuality();

        const quality = this._quality.getCurrentQuality();

        return this._quality.qualities.map(q => ({
            id: q.index,
            title: q.shortLabel,
            width: q.res.w,
            height: q.res.h,
            data: q,
            selected: q.index === quality?.index
        }));
    }

    async updateQualityLabel() {
        // const quality = this._quality?.getCurrentQuality();

        // if (quality) {
        //    this.title = quality.shortLabel;
        // }
    }

    async itemSelected(itemData) {
        const index = Number(itemData.data.index);
        const provider = this.player.videoContainer.streamProvider;

        // Az eredeti működés szerint minden streamben
        // ugyanazzal az indexszel választunk forrást.
        const targets = this.player.videoManifest.streams.map(stream => {
            const source = stream.sources?.mp4?.[index];
            const videoPlayer = provider.streams[stream.content]?.player;

            if (!source || !videoPlayer?._sources?.[index]) {
                throw new Error(
                    `Hiányzó MP4-forrás: ${stream.content}, index: ${index}`
                );
            }

            return { source, videoPlayer };
        });

        const paused = await this.player.paused();
        const timestamp =
            provider.streams.presenter.player.video.currentTime;

        for (const { source, videoPlayer } of targets) {
            videoPlayer._currentQuality = index;
            videoPlayer._currentSource = videoPlayer._sources[index];

            videoPlayer.video.src = source.src;
            videoPlayer.video.currentTime = timestamp;
        }

        this._quality = this.createVideoQuality();

        if (paused) {
            await this.player.videoContainer.pause();
        }
        else {
            await this.player.videoContainer.play();
        }

        await this.updateQualityLabel();
    }

    get titleSize() {
        return "small";
    }

    get buttonType() {
        return "radio";
    }
}

class VideoQuality {
    get qualities() {
        return this._qualities;
    }

    constructor(player, manifestSources = []) {
        this._player = player;

        this._qualities = this._player._sources.map((source, index) => {
            const manifestSource = manifestSources.find(
                item => item.src === source.src
            );

            return new QualityItem(
                source.src,
                source.res.w,
                source.res.h,
                -1,
                index,
                manifestSource?.lang ?? source.lang
            );
        });
    }

    getCurrentQuality() {
        return this._qualities[Number(this._player._currentQuality)];
    }
}

class QualityItem {
    get shortLabel() {
        return this._lang
            ? `${this._res.h}p (${this._lang})`
            : `${this._res.h}p`;
    }

    get index() {
        return this._index;
    }

    get res() {
        return this._res;
    }

    constructor(src, width, height, bitrate, index, lang) {
        this._src = src;
        this._res = {
            w: width,
            h: height
        };
        this._bitrate = bitrate;
        this._index = index;
        this._lang = lang;
    }
}
